import Vue from 'vue'
import VueRouter from 'vue-router'
import { applyInviteFromSearch } from '@/utils/channel'
import { rememberVisit } from '@/utils/visitFlow'
import { isLoggedIn } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: () => import('../views/promoters.vue')
  },
  {
    path: '/promoters',
    redirect: '/promotion'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/account',
    meta: { auth: true, shell: true },
    component: () => import('../views/account/AccountLayout.vue'),
    children: [
      { path: '', name: 'account', component: () => import('../views/account/AccountHome.vue') },
      { path: 'client', name: 'account-client', component: () => import('../views/account/AccountClient.vue') },
      { path: 'recharge', name: 'account-recharge', component: () => import('../views/account/AccountRecharge.vue') },
      { path: 'me', name: 'account-me', component: () => import('../views/account/AccountMe.vue') },
      { path: 'me/security', name: 'account-security', meta: { title: '账号安全' }, component: () => import('../views/account/AccountSecurity.vue') },
    ]
  },
  {
    path: '/termservice',
    name: 'termservice',
    component: () => import('../views/termservice.vue')
  },
  {
    path: '/registerterm',
    name: 'registerterm',
    component: () => import('../views/registerterm.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  applyInviteFromSearch(to.query)
  rememberVisit()
  if (to.matched.some(record => record.meta.auth) && !isLoggedIn()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
